import * as React from 'react';
import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { RCUtils } from '../../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../../Config.json');

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage:false };

export interface ChgReeferIdState {
    SelectedReefers: any[];
    ReeferId: string;
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters;
    VCCheckBoxInfo: VCCheckBoxData;  
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    ValidState: boolean;
}

export class ChangeReeferId extends React.Component<any, ChgReeferIdState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], ReeferId: "", RowData: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, IsCommandIssued: false, PrevSelectedItems: [], ValidState: true };
    }

    componentDidMount() {
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            this.renderChangeReeferIdGrid(this.props.reeferData);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        $('#globalLoader').hide();
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.renderChangeReeferIdGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderChangeReeferIdGrid(reeferData: any) {
        this.setState({ RowData: reeferData, ReeferId: "" });
        this.state.Filters.CommandName = "WriteConatinerID";
        this.state.Filters.SelectedReefers = reeferData;
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                //this.setState({ RowData: data, ValidState: data[0].IsValid }); //RCNG-254
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    submitReefer() {
        if (this.state.RowData.length > 0) {
            if (this.state.RowData.filter(row => row.IsPending != null && row.IsPending == 'E').length > 0) {
                var errorDescription = this.state.RowData.filter(e =>
                    e.IsPending != null && e.IsPending === 'E');
                if (errorDescription != undefined && errorDescription != null)
                    PopupWindow.showErrorMessage("Alert", errorDescription[0].Tooltip); return; //RCNG-254
            }
            var IsCT4Msg;            
            if (this.state.RowData.filter(row => row.DeviceType != null && row.DeviceType != undefined && row.DeviceType.toString().trim() == 'CT4000').length > 0)
                IsCT4Msg = true; 
            else
                IsCT4Msg = false;
            if (this.state.VCCheckBoxInfo != null && this.state.VCCheckBoxInfo.enableVCCheckBox == true && IsCT4Msg == true) { PopupWindow.showErrorMessage("Alert", "Command is not supported for vessel."); return }

            if (this.state.ReeferId != "") {
                if (this.state.ReeferId.length == 11) {
                    const IsMatch = /^[a-zA-Z]{4}[0-9]{7}$/;
                    if (IsMatch.test(this.state.ReeferId)) {
                        var command = "WriteConatinerID";
                        var paramValue = this.state.ReeferId;
                        var refreshGrid = this.props.refreshGrid;
                        ReeferCommandsGrid.submitTemperatureCommands(command, paramValue, refreshGrid);
                        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    }
                    else {
                        PopupWindow.showErrorMessage("Change ReeferId", "Please enter the ReeferID in proper format.");
                    }
                }
                else { PopupWindow.showErrorMessage("Change ReeferId", "The length Of the ReeferID should be 11."); }
            }
            else {
                PopupWindow.showErrorMessage("Change ReeferId", "Please enter ReeferID.");
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    reeferIdChange(event: React.FormEvent<HTMLInputElement>) {
        var reeferId = this.state.ReeferId;
        var Value: string = event.currentTarget.value.trim();
        reeferId = Value;
        this.setState({ ReeferId: reeferId });
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "WriteConatinerID", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    public render() {
        return <div>
            <div className="modal-controls-container" >
                <div className='row'>
                    <div className='col-lg-5 col-md-6 col-sm-6 col-xs-6 text-start text-sm-end pe-0'>
                        <label className='col-form-label'>Enter New Reefer ID :</label>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-6 col-xs-6'><input type='text' className='form-control' placeholder='' required onChange={e => this.reeferIdChange(e)} value={this.state.ReeferId} /> </div>
                </div>
            </div >
            <ReeferCommandsGrid reeferFormatter={this.props.reeferFormatter} selectedReefers={this.state.RowData} commandName={"WriteConatinerID"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)}></ReeferCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                {
                    this.state.ValidState == true ?
                        <button type='button' onClick={this.submitReefer.bind(this)} className='btn btn-primary'>Save</button>
                        :
                        <button type='button' disabled className='btn btn-primary'>Save</button>
                }
           
            </div>
        </div >
    }
}